module.exports = __webpack_public_path__ + "static/media/schedule.61857352.png";